export default "__VITE_ASSET__e2c5349e__"